import React from 'react';
import {
    Flex,
    Text,
    Button,
    Modal,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Divider,
} from '@chakra-ui/react';

const FeedbackPromptModal = (props) => {
    const { isOpen, onClose, feedbackModalOnOpen, promptUserLater } = props;

    const onAccept = () => {
        onClose();
        feedbackModalOnOpen();
    };

    const onCloseClick = () => {
        promptUserLater();
        onClose()
    }; 

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
        >
            <ModalContent mx={3} shadow='dark-lg' position='absolute' left={2} right={2} bottom={6} w='auto'>
                <ModalHeader fontWeight={700} fontSize={16} pr={12}>
                    We value your thoughts on our mobile experience!
                </ModalHeader>
                <ModalCloseButton onClick={onCloseClick} />
                <Divider />
                <ModalBody>
                    <Text fontSize={14} fontWeight={400}>
                        Can you provide some feedback on your experience so far? Or use the link in the main menu to send us feedback at any time.
                    </Text>
                </ModalBody>
                <Divider />
                    <ModalFooter display='flex' justifyContent='flex-end'>
                        <Flex size='sm' flexDirection='column' w='100%'>
                            <Button colorScheme='teal' mb={2} onClick={onAccept}>
                                I&apos;d Love To Help
                            </Button>
                            <Button variant='outline' colorScheme='teal' width='100%' onClick={onClose}>
                                Don&apos;t Ask Me Again
                            </Button>
                        </Flex>
                    </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default FeedbackPromptModal;
